import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { PagesRoutingModule } from './pages-routing.module';
import { ThemeModule } from '../@theme/theme.module';
//import { MiscellaneousModule } from './miscellaneous/miscellaneous.module';
import { RelatoriosComponent } from './relatorios/relatorios.component';
import { PerfilComponent } from './perfil/perfil.component';
// import { AutocompleteLibModule} from 'angular-ng-autocomplete';
import { SharedModule } from '../shared/shared.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ChartsModule } from 'ng2-charts';
import { MeusOrcamentosComponent } from './meus-orcamentos/meus-orcamentos.component';
import { TranslateModule } from "@ngx-translate/core";

const PAGES_COMPONENTS = [
  PagesComponent,
];

@NgModule({
  imports: [
    TranslateModule,
    PagesRoutingModule,
    ThemeModule,
    //MiscellaneousModule,
    // AutocompleteLibModule,
    SharedModule,
    ChartsModule,
  ],
  declarations: [
    ...PAGES_COMPONENTS,
    RelatoriosComponent,
    PerfilComponent,
    DashboardComponent,
    MeusOrcamentosComponent
  ],
})
export class PagesModule {

}
